<script lang="ts">import { Button } from "@infinitro/button";
import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { ModalDialog, pushModal } from "@infinitro/global";
const logoSrc = cfgToThemeCdnPath("/misc/logo.svg");
const bannerMobileSrc = cfgToThemeCdnPath("/about-vip/banner-mobile.png");
const bannerSrc = cfgToThemeCdnPath("/about-vip/banner.png");
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
</script>

<div class="vip-hero">
	<img
		class="vip-hero-banner-mobile"
		src={bannerMobileSrc}
		alt={$t(Verbiage.vip_icons_alt, 'alts')}
	/>
	<img class="vip-hero-banner" src={bannerSrc} alt={$t(Verbiage.vip_icons_alt, 'alts')} />
	<div class="vip-hero-overlay"></div>
	<div class="vip-hero-content">
		<div class="vip-hero-brand">
			<img class="vip-hero-logo" src={logoSrc} alt={$t(Verbiage.site_logo_alt, 'alts')} />
			<h1 class="vip-hero-title">{$t(Verbiage['vip_momentum_hero_title'])}</h1>
			<p class="vip-hero-tagline">{$t(Verbiage['vip_momentum_hero_tagline'])}</p>
		</div>
		<div class="vip-hero-bottom">
			<div class="vip-hero-copy">
				<p>{$t(Verbiage['vip_momentum_hero_body1'])}</p>
				<p>{$t(Verbiage['vip_momentum_hero_body2'])}</p>
			</div>
			<Button
				text={$t(Verbiage['vip_momentum_hero_cta'])}
				variant="primary"
				minWidth
				onClick={handleSignup}
			/>
		</div>
	</div>
</div>

<style>
	.vip-hero {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		overflow: hidden;
		background: linear-gradient(95.94deg, #1a1e45 3.09%, #33172d 98.97%);
		border-radius: 0;
		aspect-ratio: 786 / 1268;
		/* full-bleed out of every centered/padded ancestor (Container's 92vw max-width, our own px-4, etc.) */
		width: 100vw;
		margin-left: calc(50% - 50vw);
		margin-right: calc(50% - 50vw);
		/* cancel Container's own py-6 top padding so the hero sits flush under the header */
		margin-top: -1.5rem
}

	.vip-hero-banner-mobile {
		position: absolute;
		inset: 0px;
		z-index: 0;
		height: 100%;
		width: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
		-o-object-position: top;
		   object-position: top
}

	.vip-hero-banner {
		display: none
}

	.vip-hero-overlay {
		position: absolute;
		inset: 0px;
		z-index: 1;
		background: linear-gradient(
			0.06deg,
			var(--color-background-100) 7.55%,
			color-mix(in srgb, var(--color-background-100) 90%, transparent) 15.94%,
			color-mix(in srgb, var(--color-background-100) 75%, transparent) 24.32%,
			color-mix(in srgb, var(--color-background-100) 50%, transparent) 34.92%,
			transparent 45.95%
		)
}

	.vip-hero-content {
		position: relative;
		z-index: 10;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 2rem;
		padding-bottom: 2rem;
		text-align: center
}

	.vip-hero-brand {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0px
}

	.vip-hero-tagline {
		margin-top: 0.5rem;
		font-family: 'DM Sans';
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	.vip-hero-logo {
		height: 2rem;
		width: auto;
		-o-object-fit: contain;
		   object-fit: contain
}

	.vip-hero-title {
		font-family: 'DM Sans';
		font-size: 32px;
		font-weight: 900;
		line-height: 120%;
		letter-spacing: 0;
		background-image: linear-gradient(to top, var(--tw-gradient-stops));
		--tw-gradient-from: #F29838 var(--tw-gradient-from-position);
		--tw-gradient-to: rgb(242 152 56 / 0) var(--tw-gradient-to-position);
		--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
		--tw-gradient-from-position: 41.83%;
		--tw-gradient-to: #F9D047 var(--tw-gradient-to-position);
		-webkit-background-clip: text;
		        background-clip: text;
		color: transparent
}

	.vip-hero-bottom {
		display: flex;
		width: 100%;
		max-width: 395px;
		flex-direction: column;
		align-items: center;
		gap: 1rem
}

	.vip-hero-copy {
		display: flex;
		flex-direction: column;
		gap: 0.25rem
}

	.vip-hero-copy p {
		font-family: 'DM Sans';
		font-size: 1rem;
		line-height: 1.5rem;
		line-height: 1.2;
		letter-spacing: 0.02em;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	@media (min-width: 1024px) {
		.vip-hero {
				flex-direction: row;
				align-items: center;
			aspect-ratio: auto;
			height: 357px;
			border-radius: 20px;
			width: 100%;
			margin-left: 0;
			margin-right: 0;
			margin-top: 0
		}

		.vip-hero-banner-mobile {
				display: none
		}

		.vip-hero-overlay {
				display: none
		}

		.vip-hero-banner {
				position: absolute;
				right: 0px;
				top: 0px;
				display: block;
				height: 100%;
				width: auto;
				max-width: none;
				-o-object-fit: contain;
				   object-fit: contain;
				-o-object-position: right;
				   object-position: right
		}

		.vip-hero-content {
				height: 100%;
				width: auto;
				align-items: flex-start;
				justify-content: space-between;
				padding-left: 2rem;
				padding-right: 2rem;
				padding-top: 2.5rem;
				padding-bottom: 2.5rem;
				text-align: left;
			max-width: 560px
		}

		.vip-hero-brand {
				align-items: flex-start
		}

		.vip-hero-logo {
				height: 2.5rem
		}

		.vip-hero-title {
				font-size: 60px
		}

		.vip-hero-bottom {
				align-items: flex-start
		}
	}
</style>
